import { isUserStateLoadingSelector as isUserStateLoading } from '../redux/selectors/profile';

export default {
  selectors: { isUserStateLoading },
};
